/**
 * Class names for `Branding` components (src/components/Branding/).
 */
export const brandingClassNames = {
  fixitLogoImg: "fixit-logo__img",

  stripeBadgeAnchor: "stripe-badge__anchor", // component root
  stripeBadgeImg: "stripe-badge__img",

  titleLogoRoot: "title-logo__root",
  titleLogoImg: "title-logo__img",
  titleLogoText: "title-logo__text",
} as const;
